import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { PaginationModel } from '../../../../../../shared/model/pagination.model';
import { AgGridI, VendorPartLibraryPaginationModel } from '../../../../../../shared/components/ag-grid/ag-grid.model';
import { agGridDataModelImages } from '../../../pages/part-inventory/in-stock/instock.model';
import { AgGridComponent } from '../../../../../../shared/components/ag-grid/ag-grid.component';
import { AgGridDataModelRequestVendor } from '../../../part-list.model';
import { VendorPartsLibraryService } from '../../../../vendor-parts-library/pages/vendor-parts-library/vendor-parts-library.service';

@Component({
  selector: 'app-select-vendor-tab',
  templateUrl: './select-vendor-tab.component.html',
  styleUrls: ['./select-vendor-tab.component.scss']
})
export class SelectVendorTabComponent implements OnInit {
  AgGridDataModel: AgGridI;
  gridApiForDataModel: any
  @ViewChildren(AgGridComponent) grids: QueryList<AgGridComponent>
  @Input()  data:any ={}
  paginationModel : any = {};
  constructor(public vplService: VendorPartsLibraryService,) {
   }
  ngOnInit(): void {
    this.AgGridDataModel = AgGridDataModelRequestVendor;
  }
  onPagination(pagination: PaginationModel) {
    this.paginationModel.pageNumber = pagination?.pageNumber;
    this.paginationModel.pageSize = pagination?.pageSize;
    this.paginationModel.getAll = pagination?.getAll;
    this.getVplList();
  }
    getRowStyle = (params: any) => {
      return { borderBottom: '1px solid #E9EDF2' };
    };
    
    onSelectionChange(params) {
      let data = params?.api?.getSelectedRows();
      this.data.selectedRowData = [...data];
      if (data.length === 0) {
       this.data.confirmedData = [];
       this.data.paginatedItems = [];
      }
    }
    onGridReady(event) {
      this.gridApiForDataModel = event;
  }
getVplList() {
  if(this.data?.selectedRowData?.length){
this.data.selectedRowData = []
  }
   let  gridRef = this.grids?.first;
    if (gridRef) {
      gridRef.agGridPaginationConfig.rows = [];
      gridRef.showLoading(this.gridApiForDataModel);
      this.vplService?.getAllRequestVPL(this.paginationModel).subscribe({
        next: (res) => {
          gridRef.hideLoading(this.gridApiForDataModel);
          if (res?.isSuccess) {
            const dataList = res?.response ?? [];
            this.gridApiForDataModel?.api?.setRowData(dataList);
            gridRef.updatePaginationData(this.paginationModel, res.totalRecords);
          } else {
            this.gridApiForDataModel?.api?.setRowData([]);
          }
        },
        error: () => {
          gridRef.hideLoading(this.gridApiForDataModel);
          this.gridApiForDataModel?.api?.setRowData([]);
        }
      });
    }
  }

}
